module.exports = __webpack_public_path__ + "img/logo_caes_gatos.1a929b19.png";